import {AppLocalStorage} from "@services/utils";

export default function () {
  return {
    user: JSON.parse(AppLocalStorage.getItem('adminAuth.user')),
    token: AppLocalStorage.getItem('adminAuth.token'),
    expire_time: Number(AppLocalStorage.getItem('adminAuth.expire_time'))
  }
}
